import script from "./TableForRejectReason.vue?vue&type=script&setup=true&lang=js"
export * from "./TableForRejectReason.vue?vue&type=script&setup=true&lang=js"

import "./TableForRejectReason.vue?vue&type=style&index=0&id=5c6951c5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c6951c5"]])

export default __exports__